import { render, staticRenderFns } from "./EditableDay.vue?vue&type=template&id=33672dfd&scoped=true&"
import script from "./EditableDay.vue?vue&type=script&lang=js&"
export * from "./EditableDay.vue?vue&type=script&lang=js&"
import style0 from "./EditableDay.vue?vue&type=style&index=0&id=33672dfd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33672dfd",
  null
  
)

export default component.exports